import { Paper } from '@mui/material';
import { useCarouselCardStyles } from './carousel-card.styles';

const CarouselCard = ({ work, active }) => {
  const classes = useCarouselCardStyles();

  return (
    <Paper
      elevation={2}
      sx={{
        backgroundImage: `url(${work.image.url})`,
      }}
      className={`${classes.cCard} ${active ? classes.cCActive : ''}`}
    />
  );
};

export default CarouselCard;
